export enum CollectionStatus {
  ACTIVE = 'ACTIVE',
  DISABLE = 'DISABLE',
}
